export const FEEDBACK_CATEGORIES = ['bug', 'improvement', 'question'] as const;

export type FeedbackCategory = (typeof FEEDBACK_CATEGORIES)[number];

type CategoryMeta = {
  icon: string;
  shortLabel: string;
  detailedLabel: string;
};

const FEEDBACK_CATEGORY_META: Record<FeedbackCategory, CategoryMeta> = {
  bug: {
    icon: '🐛',
    shortLabel: 'Bug',
    detailedLabel: 'Bug Report',
  },
  improvement: {
    icon: '💡',
    shortLabel: 'Improvement',
    detailedLabel: 'Improvement Idea',
  },
  question: {
    icon: '❓',
    shortLabel: 'Question',
    detailedLabel: 'Question',
  },
};

export const FEEDBACK_CATEGORY_ICON_BY_VALUE: Record<FeedbackCategory, string> = {
  bug: FEEDBACK_CATEGORY_META.bug.icon,
  improvement: FEEDBACK_CATEGORY_META.improvement.icon,
  question: FEEDBACK_CATEGORY_META.question.icon,
};

export function isFeedbackCategory(value: string): value is FeedbackCategory {
  return (FEEDBACK_CATEGORIES as readonly string[]).includes(value);
}

export function buildCategoryOptionsHtml(
  categories: readonly FeedbackCategory[],
  variant: 'short' | 'detailed',
): string {
  return categories
    .map((category) => {
      const meta = FEEDBACK_CATEGORY_META[category];
      const label = variant === 'detailed' ? meta.detailedLabel : meta.shortLabel;
      return `<option value="${category}">${meta.icon} ${label}</option>`;
    })
    .join('');
}